import {
  REQUEST_UPDATE_CUSTOMER_PROPS,
  REQUEST_GET_CUSTOMER_PROPS,
  REQUEST_GET_USER_CIDN_ASSOCIATION,
  REQUEST_REMOVE_USER_CIDN_ASSOCIATION,
  REQUEST_GET_USER_DETAILS,
  REQUEST_UPDATE_USER_DETAILS,
  REQUEST_GET_CUSTOMER_CUSTOM_PROPS,
  REQUEST_UPDATE_CUSTOMER_CUSTOM_PROPS,
  REQUEST_GET_USER_CUSTOM_PROPS,
  REQUEST_UPDATE_USER_CUSTOM_PROPS,
  REQUEST_UPDATE_USER_STATUS,
  REQUEST_GET_USER_SERVICES,
  REQUEST_UPDATE_USER_SERVICE
} from '../actions/action-types'
import { IOpsHubState } from '../state'
import { initialState } from '@telstra-connect/ops-hub/state/initial-state'
import { IReducersMap, reducer } from '@telstra-connect/standard-actions/reducers'
import {
  postUpdateCustomerPropsReducer,
  PostUpdateCustomerPropsAction,
} from './update-customer-props'
import { getCustomerPropsReducer, GetCustomerPropsAction } from './get-customer-props'
import {
  getUserCidnAssociationReducer,
  GetUserCidnAssociationAction,
} from './get-user-cidn-association'
import {
  removeUserCidnAssociationReducer,
  RemoveUserCidnAssociationAction,
} from './remove-user-cidn-association'
import { GetUserDetailsAction, getUserDetailsReducer } from './get-user-details'
import { PostUpdateUserDetailsAction, postUpdateUserDetailsReducer } from './update-user-details'
import { GetCustomerCustomPropsAction, getCustomerCustomPropsReducer } from './get-customer-custom-props'
import { PostCustomerCustomPropsAction, postUpdateCustomerCustomPropsReducer } from './update-customer-custom-props'
import { GetUserCustomPropsAction, getUserCustomPropsReducer } from './get-user-custom-props'
import { postUpdateUserCustomPropsReducer, PostUserCustomPropsAction } from './update-user-custom-props'
import { postUpdateUserStatusReducer, PostUpdateUserStatusAction } from './update-user-status'
import { getUserServicesReducer } from './get-user-services'
import { postUpdateUserServiceReducer } from './update-user-service'

type OpsHubAction =
  | PostUpdateCustomerPropsAction
  | GetCustomerPropsAction
  | GetCustomerCustomPropsAction
  | GetUserCidnAssociationAction
  | RemoveUserCidnAssociationAction
  | GetUserDetailsAction
  | PostUpdateUserDetailsAction
  | PostCustomerCustomPropsAction
  | GetUserCustomPropsAction
  | PostUserCustomPropsAction
  | PostUpdateUserStatusAction

const reducersMap: IReducersMap<IOpsHubState> = {
  [REQUEST_UPDATE_CUSTOMER_PROPS]: postUpdateCustomerPropsReducer,
  [REQUEST_UPDATE_CUSTOMER_CUSTOM_PROPS]: postUpdateCustomerCustomPropsReducer,
  [REQUEST_UPDATE_USER_CUSTOM_PROPS]: postUpdateUserCustomPropsReducer,
  [REQUEST_GET_CUSTOMER_PROPS]: getCustomerPropsReducer,
  [REQUEST_GET_CUSTOMER_CUSTOM_PROPS]: getCustomerCustomPropsReducer,
  [REQUEST_GET_USER_CUSTOM_PROPS]: getUserCustomPropsReducer,
  [REQUEST_GET_USER_CIDN_ASSOCIATION]: getUserCidnAssociationReducer,
  [REQUEST_REMOVE_USER_CIDN_ASSOCIATION]: removeUserCidnAssociationReducer,
  [REQUEST_GET_USER_DETAILS]: getUserDetailsReducer,
  [REQUEST_UPDATE_USER_DETAILS]: postUpdateUserDetailsReducer,
  [REQUEST_UPDATE_USER_STATUS]: postUpdateUserStatusReducer,
  [REQUEST_GET_USER_SERVICES]: getUserServicesReducer,
  [REQUEST_UPDATE_USER_SERVICE]: postUpdateUserServiceReducer
}

export const reducers = reducer<IOpsHubState, OpsHubAction>(reducersMap, initialState)
